
<template>
  <!-- start::穿梭弹出框 -->
  <el-dialog width="80%" top="10vh" :append-to-body="true" :visible.sync='settingQueryMoudle.show' title="配置查询模型">
    <el-row :gutter="20">
      <!-- 穿梭框数据表一 -->
      <el-col :span="16">
        <easyCruds ref="dataSourceOne" :tableInfo='dataSourceOne' @loadDataSourceOne="loadDataSourceOne">
          <template slot="queryTypeSlot" slot-scope="{row}">
            <el-select size="mini" @change="change(row)" v-model="row['queryType']" placeholder="请选择">
              <el-option label="无" value="none"></el-option>
              <el-option label="精确" value="accurate"></el-option>
              <el-option label="模糊" value="blurry"></el-option>
              <el-option label="时间范围" value="timeRange"></el-option>
              <el-option label="日期范围" value="dateRange"></el-option>
            </el-select>
          </template>
          <template slot="orderTypeSlot" slot-scope="{row}">
            <el-select size="mini" @change="change(row)" v-model="row['orderType']" placeholder="请选择">
              <el-option label="无" value="none"></el-option>
              <el-option label="正序" value="asc"></el-option>
              <el-option label="倒序" value="desc"></el-option>
            </el-select>
          </template>
          <template slot="orderPrioritySlot" slot-scope="{row}">
            <el-input v-model="row['orderPriority']" @blur="change(row)"></el-input>
          </template>
        </easyCruds>
      </el-col>
      <!-- 穿梭框 炒作区域 -->
      <el-col :span="1">
        <!-- <div class="el-transfer__buttons" style="margin-top:200%;">
        <button @click="toLeft" type="button" class="el-button el-button--primary  el-transfer__button">
                            <span>
                            <i class="el-icon-arrow-left"></i>
                            </span>
                        </button>
        <button @click="toRight" type="button" class="el-button el-button--primary  el-transfer__button">
                            <span>
                            <i class="el-icon-arrow-right"></i>
                            </span>
                        </button>
      </div>-->
        <div style="height:500px; position: relative; ">
          <el-row style="top:200px;">
            <el-button @click="toLeft" icon="el-icon-arrow-left" type="primary" class=" el-transfer__button">
            </el-button>
          </el-row>
          <el-row style="top:200px;">
            <el-button @click="toRight" icon="el-icon-arrow-right" type="primary" class=" el-transfer__button">
            </el-button>
          </el-row>
        </div>
      </el-col>
      <!-- 穿梭框数据表二 -->
      <el-col :span="7">
        <easyCruds ref="dataSourceTwo" :tableInfo='dataSourceTwo' @loadDataSourceTwo="loadDataSourceTwo"></easyCruds>
      </el-col>
    </el-row>
  </el-dialog>
  <!-- end::穿梭弹出框 -->
</template>

<script>
export default {
  props: ['settingQueryMoudle'],
  data() {
    return {
      dataSourceOne: {
        header: {
          title: '已显示项'
        },
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowView: false,
          allowDelete: false
        },
        table: {
          loading: false,
          height: 500,
          stripe: true,
          selection: true,
          index: false,
          columns: [{
            prop: 'prop',
            label: '字段名称'
          }, {
            prop: 'label',
            label: '显示名称'
          }, {
            prop: 'queryType',
            label: '查询类型',
            slotName: 'queryTypeSlot'
          }, {
            prop: 'orderType',
            label: '排序类型',
            slotName: 'orderTypeSlot'
          }, {
            prop: 'orderPriority',
            label: '排序优先级',
            width: 210,
            slotName: 'orderPrioritySlot'
          }],
          operation: {
            width: '0',
            operations: []
          },
          tableData: [],
          reload: 'loadDataSourceOne',
          reloadConditions: {}
        }
      },
      dataSourceTwo: {
        header: {
          title: '未显示项'
        },
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowView: false,
          allowDelete: false
        },
        table: {
          loading: false,
          height: 500,
          stripe: true,
          selection: true,
          index: false,
          columns: [{
            prop: 'prop',
            label: '字段名称'
          }, {
            prop: 'label',
            label: '显示名称'
          }],
          operation: {
            width: '0',
            operations: []
          },
          tableData: [],
          reload: 'loadDataSourceOne',
          reloadConditions: {}
        }
      }

    }
  },
  methods: {
    loadDataSourceOne() {
      this.dataSourceOne.table.loading = true
      this.$http.get('/form-model/added-column-list', {
        params: {
          formId: this.settingQueryMoudle.id
        }
      }).then(response => {
        this.dataSourceOne.table.loading = false
        this.dataSourceOne.table.tableData = response.data
      }).catch(error => {
        this.dataSourceOne.table.loading = false
        this.$message.error(error.msg || error.message)
      })
    },
    loadDataSourceTwo() {
      this.dataSourceTwo.table.loading = true
      this.$http.get('/form-model/not-added-column-list', {
        params: {
          formId: this.settingQueryMoudle.id
        }
      }).then(response => {
        this.dataSourceTwo.table.loading = false
        this.dataSourceTwo.table.tableData = response.data
      }).catch(error => {
        this.dataSourceTwo.table.loading = false
        this.$message.error(error.msg || error.message)
      })
    },
    Initialize() {
      this.dataSourceOne.table.tableData = this.dataSourceOne.table.tableData = []
      this.loadDataSourceOne()
      this.loadDataSourceTwo()
    },
    toLeft() {
      // 获取下选择的数据
      let options = this.$refs.dataSourceTwo.getSelectedRows()
      if (options.length !== 0) {
        this.Modify(options, true).then(response => {
          this.loadDataSourceOne()
          this.loadDataSourceTwo()
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      } else {
        this.$message.info('请至少选择一条数据再操作')
      }
    },
    toRight() {
      // 获取下选择的数据
      let options = this.$refs.dataSourceOne.getSelectedRows()
      if (options.length !== 0) {
        this.delete(options).then(response => {
          this.loadDataSourceOne()
          this.loadDataSourceTwo()
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      } else {
        this.$message.info('请至少选择一条数据再操作')
      }
    },
    Modify(formQueryModelList, add) {
      if (add) {
        formQueryModelList.forEach(element => {
          delete element.id
        })
      }
      return this.$http.post('/form-model/update-query-model', formQueryModelList)
    },
    delete(formQueryModelList) {
      return this.$http.post('/form-model/delete-query-model', formQueryModelList.map(item => ({ id: item.id })))
    },
    change(row) {
      if (!row.queryType) { row.queryType = 'none' }
      if (!row.orderType) { row.orderType = 'none' }
      row.propJson = null
      console.log(typeof row.orderPriority)
      row.orderPriority = typeof parseInt(row.orderPriority) === 'number' && !isNaN(parseInt(row.orderPriority)) ? row.orderPriority : 0
      this.dataSourceOne.table.loading = true
      this.Modify([row]).then(response => {
        this.dataSourceOne.table.loading = false
      }).catch(e => {
        this.dataSourceOne.table.loading = false
      })
    }
  }

}
</script>
<style lang='scss' scoped>
:deep(.el-dialog__body) {
  padding-top: 0px;
}
</style>
